module.exports = __webpack_public_path__ + "static/Catalogues-fa136d71a794f468e81b94d5ae9a6c33.svg";